// Printer Configuration - Kprinter JK-5802H (58mm Thermal Receipt Printer)
export const PRINTER_CONFIG = {
  brand: 'Kprinter',
  model: 'JK-5802H',
  paperWidth: '58mm',
  printWidth: '48mm',
  dpi: 203,
  interface: 'USB/Bluetooth',
  characterSet: 'UTF-8',
  bluetoothServiceUUID: '000018f0-0000-1000-8000-00805f9b34fb',
  bluetoothCharacteristicUUID: '00002af1-0000-1000-8000-00805f9b34fb',
  altServiceUUID: '49535343-fe7d-4ae5-8fa9-9fafd205e455',
  altCharacteristicUUID: '49535343-8841-43f4-a8d4-ecbe34729bb3'
};

// ESC/POS Commands for thermal printers
export const ESC_POS = {
  INIT: [0x1B, 0x40],
  ALIGN_CENTER: [0x1B, 0x61, 0x01],
  ALIGN_LEFT: [0x1B, 0x61, 0x00],
  ALIGN_RIGHT: [0x1B, 0x61, 0x02],
  BOLD_ON: [0x1B, 0x45, 0x01],
  BOLD_OFF: [0x1B, 0x45, 0x00],
  DOUBLE_HEIGHT_ON: [0x1B, 0x21, 0x10],
  DOUBLE_WIDTH_ON: [0x1B, 0x21, 0x20],
  DOUBLE_ON: [0x1B, 0x21, 0x30],
  NORMAL: [0x1B, 0x21, 0x00],
  LINE_FEED: [0x0A],
  CUT_PAPER: [0x1D, 0x56, 0x00],
  PARTIAL_CUT: [0x1D, 0x56, 0x01],
  FEED_AND_CUT: [0x1D, 0x56, 0x42, 0x18],
};

export const textToBytes = (text) => {
  const encoder = new TextEncoder();
  return Array.from(encoder.encode(text));
};

export const formatLine = (left, right = '', width = 32) => {
  const leftStr = String(left).substring(0, width - right.length - 1);
  const rightStr = String(right);
  const spaces = width - leftStr.length - rightStr.length;
  return leftStr + ' '.repeat(Math.max(1, spaces)) + rightStr;
};

export const centerText = (text, width = 32) => {
  const str = String(text).substring(0, width);
  const padding = Math.floor((width - str.length) / 2);
  return ' '.repeat(Math.max(0, padding)) + str;
};

export const dashedLine = (width = 32) => '-'.repeat(width);

export const formatReceiptCurrency = (amount) => {
  return `P${(amount || 0).toFixed(2)}`;
};

export const getWholesaleUnit = (product) => {
  const unitType = product?.unitType || '';
  if (unitType.includes('CASE')) return { singular: 'case', plural: 'cases' };
  if (unitType.includes('BOX')) return { singular: 'box', plural: 'boxes' };
  return { singular: 'sack', plural: 'sacks' };
};

export const getRetailUnit = (product) => {
  const unitType = product?.unitType || '';
  if (unitType.includes('BOTTLE')) return { singular: 'bottle', plural: 'bottles' };
  if (unitType.includes('PIECE')) return { singular: 'piece', plural: 'pieces' };
  if (unitType.includes('PACK')) return { singular: 'pack', plural: 'packs' };
  return { singular: 'kg', plural: 'kg' };
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(amount || 0);
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString('en-PH', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true
  });
};
